var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFilePdf = function SvgIconFilePdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.125 11.625v-7.25h7.75v5a1 1 0 0 0 1 1h5v1.25a1 1 0 1 0 2 0v-3a1 1 0 0 0-.293-.707l-5.25-5.25a1 1 0 0 0-.707-.293h-9.75a1.75 1.75 0 0 0-1.75 1.75v7.5a1 1 0 1 0 2 0m9.75-6.586v3.336h3.336z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.375 14.375a1 1 0 0 0-1 1v5.25a1 1 0 1 0 2 0v-1.25H21a1 1 0 1 0 0-2h-1.625v-1h2a1 1 0 1 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.5 15.375a1 1 0 0 1 1-1H12a3.625 3.625 0 0 1 0 7.25h-1.5a1 1 0 0 1-1-1zm2 1v3.25h.5a1.625 1.625 0 1 0 0-3.25zM3.375 14.375a1 1 0 0 0-1 1v5.25a1 1 0 1 0 2 0v-.5h.5a2.875 2.875 0 1 0 0-5.75zm1.5 3.75h-.5v-1.75h.5a.875.875 0 0 1 0 1.75",
    clipRule: "evenodd"
  }))));
};
export default SvgIconFilePdf;